export function SessionSyncNotice({ message }: { message: string }) {
  return message ? <div className="global-error" role="status">{message}<a href="/extension">检查插件连接</a></div> : null;
}
